module.exports = __webpack_public_path__ + "static/media/strava.4ea1150b.svg";